import { render } from "./JzIcon.vue?vue&type=template&id=3e34187c&scoped=true"
import script from "./JzIcon.vue?vue&type=script&lang=js"
export * from "./JzIcon.vue?vue&type=script&lang=js"

import "./JzIcon.vue?vue&type=style&index=0&id=3e34187c&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e34187c"]])

export default __exports__